import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Button-specific class variants. Color/variant/size visual chrome is delegated to e-card.
 * These classes are passed to e-card's `class` prop and land on the card's inner element,
 * where `--card-color` is already set — so hover references to `--card-color` resolve correctly.
 */
export const buttonClasses = defineVariants({
  base: `
    inline-flex! flex-row! items-center! justify-center! gap-2!
    font-medium
    cursor-pointer
    outline-none
    transition-colors
    select-none
    focus-visible:ring-2 focus-visible:ring-(--color-foreground)
  `,
  icon: `flex-shrink-0`,
  label: `truncate`,

  variants: {
    variant: {
      solid: `hover:bg-(--card-color)/75`,
      outline: `hover:bg-(--card-color)/10`,
      soft: `hover:bg-(--card-color)/25`,
      subtle: `hover:bg-(--card-color)/25`,
      ghost: `hover:bg-(--card-color)/10`,
      link: `pb-px! hover:border-b hover:border-b-(--card-color) hover:pb-0!`,
    },

    size: {
      xs: `px-2! h-6! text-xs rounded!`,
      sm: `px-2.5! h-8! text-sm rounded-md!`,
      md: `px-3! h-10! text-base rounded-lg!`,
      lg: `px-4! h-12! text-lg rounded-lg!`,
      xl: `px-5! h-14! text-xl rounded-lg!`,
    },

    square: {
      true: `aspect-square px-0!`,
      false: ``,
    },

    block: {
      true: `w-full!`,
      false: `w-auto!`,
    },

    disabled: {
      true: `opacity-50 cursor-not-allowed!`,
      false: ``,
    },

    loading: {
      true: `cursor-progress`,
      false: ``,
    },
  },

  defaults: {
    variant: "subtle",
    size: "md",
    square: "false",
    block: "false",
    disabled: "false",
    loading: "false",
  },

  compoundVariants: [
    {
      variant: "link",
      class: "px-[0px]!",
    },
    {
      variant: "link",
      size: ["xs", "sm"],
      class: "border-b-1!",
    },
  ],
});
